import script from "./clinic-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-dashboard.vue?vue&type=script&setup=true&lang=js"

import "./clinic-dashboard.vue?vue&type=style&index=0&id=47168f34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47168f34"]])

export default __exports__